const WAYBACK_PATH_RE = /^https?:\/\/web\.archive\.org\/web\/([^/]+)\//i;

/** Site URL’sine şema ekler (https varsayılan) */
export function normalizeSiteUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

/** Internet Archive “tüm anlıklar” araması — hedef URL encode edilmez */
export function buildWaybackWildcardUrl(siteUrl: string): string {
  return `https://web.archive.org/web/*/${normalizeSiteUrl(siteUrl)}`;
}

/** Kayıtlı veya hatalı üretilmiş wayback linklerini düzeltir (encode edilmiş path vb.) */
export function normalizeWaybackArchiveUrl(waybackUrl: string): string {
  const trimmed = waybackUrl.trim();
  const match = trimmed.match(WAYBACK_PATH_RE);
  if (!match) return trimmed;

  const timestamp = match[1];
  let target = trimmed.slice(match[0].length);

  if (!target) return trimmed;

  if (/%[0-9A-Fa-f]{2}/.test(target)) {
    try {
      target = decodeURIComponent(target);
    } catch {
      /* orijinal hedef kalsın */
    }
  }

  if (!/^https?:\/\//i.test(target)) {
    target = normalizeSiteUrl(target);
  }

  return `https://web.archive.org/web/${timestamp}/${target}`;
}

export function resolveWaybackHref(
  waybackUrl?: string | null,
  siteUrl?: string | null
): string | null {
  const stored = waybackUrl?.trim();
  if (stored) return normalizeWaybackArchiveUrl(stored);

  const site = siteUrl?.trim();
  if (!site) return null;

  if (/web\.archive\.org/i.test(site)) {
    return normalizeWaybackArchiveUrl(site);
  }

  return buildWaybackWildcardUrl(site);
}
